// extracted by mini-css-extract-plugin
export default {"container":"V2-z","contained":"W2-z","products":"X2-z","cta":"Y2-z","disabled":"Z2-z"};